module.exports = __webpack_public_path__ + "static/media/clouds-moon.68a048e6.svg";